export function areStyleSheetsEqual(a, b) {
    if (a === b)
        return true;
    if (!a || !b)
        return false;
    return a.equals(b);
}
